// removed by extract-text-webpack-plugin
module.exports = {"container":"styles--container--WuDCSRVx","title":"styles--title--2OP4okUl","subtitle":"styles--subtitle--S7N9AMiO"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Layout/TitleBar/styles.css
// module id = 969
// module chunks = 2